import { SimpleMenu } from "@components";
import { useTranslation } from "react-i18next";

const MyMenu = function ({ active }) {
  const { t } = useTranslation();

  return (
    <SimpleMenu
      title={t("jaringan")}
      active={active}
      menu={[
        {
          text: t("jaringan_kantor"),
          link: "/network/kantor",
        },
        {
          text: t("jaringan_atm"),
          link: "/network/atm",
        },
      ]}
    />
  );
};
export default MyMenu;
